import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}`}
    width={`${size}`}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <g transform="translate(3 3)" stroke={color} strokeWidth="2" fill="none" fillRule="evenodd">
      <circle cx="9" cy="9" r="9" />
      <path d="M5 9H0M18 9h-5" />
      <path
        d="M6 8h6l1 2-2.2111 1.1056A3.236 3.236 0 0 0 9 14a3.236 3.236 0 0 0-1.7889-2.8944L5 10l1-2Z"
        strokeLinejoin="round"
      />
      <path d="M9 12v6" />
    </g>
  </svg>
);
